import React from 'react';
import styled from 'styled-components';
import { blue100, slate30 } from '@zocdoc-mezzanine/foundations-colors';
import {
    headingLarge,
    labelMedium,
} from '@zocdoc-mezzanine/foundations-typography';
import { TableGrid } from './TableGrid';

/**
 * Individual ListingPages-Popup tab for a particular specialty
 * @param {Object} specialty  -- Contains specialty name and url segment
 * @param {Array} cities -- List of cities with name and url segment
 * @param {Boolean} isActive  -- Whether tab is currently displayed
 * @param {function} setActive -- Callback for setting current tab to active
 * @param {string} hostOverride
 * @returns {JSX.Element}
 */
export const SpecialtyTab = ({
    specialty,
    cities,
    isActive,
    setActive,
    hostOverride = '',
}) => (
    <>
        <TabSelector
            data-test={`listing-page-popup-${specialty.name}-selector`}
            onMouseOver={setActive}
            $active={isActive}
            tabIndex="0"
        >
            {specialty.name}
        </TabSelector>

        <TableTabContainer data-test={`${specialty.name}-section`}>
            <TableContentsContainer $active={isActive}>
                <TableTitle>Browse {specialty.name} near you </TableTitle>
                <TableGrid
                    cities={cities}
                    specialty={specialty}
                    hostOverride={hostOverride}
                />
            </TableContentsContainer>
        </TableTabContainer>
    </>
);

const TabSelector = styled.div`
    display: inline-block;
    margin-right: 24px;
    ${labelMedium};
    &:hover {
        opacity: 1;
    }
    border-bottom: ${(p) => (p.$active ? '2px solid ' + blue100 : 'none')};
    opacity: ${(p) => (p.$active ? 1 : 0.6)};
    cursor: pointer;
`;

const TableTabContainer = styled.div`
    display: inline-block;
`;

const TableContentsContainer = styled.div`
    display: ${(p) => (p.$active ? 'block' : 'none')};
    padding-top: 30px;
    position: absolute;
    top: 28px;
    left: 0;
    right: 0;
    border-top: 2px solid ${slate30};
`;

const TableTitle = styled.div`
    ${headingLarge};
    margin-bottom: 24px;
`;
